// AUTO-GENERATED by scripts/sync-adrenal-gauge-ids.js. DO NOT EDIT BY HAND.
// Source: https://docs.google.com/spreadsheets/d/1mDb8FG3oQhEvYmMeCNDioqSvh7V76ClEQsKU_-aDh5M/edit?gid=400237341 (tab "Adrenal Gauge")
// Last synced: 2026-08-31T18:18:54.925Z
//
// Gauge state signature -> the Adrenal Gauge tab row that explains it. See the
// script header for the signature format; adrenalGauge() rebuilds the same
// string from its own counters.

export const ADRENAL_GAUGE_IDS: { [signature: string]: number } = {
  "balanced|5": 90400,
  "balanced|15": 90401,
  "balanced|25": 90402,
  "underactivity|low|Na/K|all mild": 90403,
  "underactivity|low|Na/K|one past mid": 90404,
  "underactivity|low|Na/K|one past lab range": 90405,
  "underactivity|low|Na/K|one past alarm bound": 90406,
  "underactivity|low|Cortisol|all mild": 90407,
  "underactivity|low|Cortisol|one past mid": 90408,
  "underactivity|low|Cortisol|one past lab range": 90409,
  "underactivity|low|Cortisol|one past alarm bound": 90410,
  "underactivity|low|Na/K,Cortisol|all mild": 90411,
  "underactivity|low|Na/K,Cortisol|one past mid": 90412,
  "underactivity|low|Na/K,Cortisol|two or more past mid": 90413,
  "underactivity|low|Na/K,Cortisol|one past lab range": 90414,
  "underactivity|low|Na/K,Cortisol|one past alarm bound": 90415,
  "underactivity|low|Na/K,Cortisol|two past lab range": 90416,
  "underactivity|low|Na/K,DHEA-S|all mild": 90417,
  "underactivity|low|Na/K,DHEA-S|one past mid": 90418,
  "underactivity|low|Na/K,DHEA-S|two or more past mid": 90419,
  "underactivity|low|Na/K,DHEA-S|one past lab range": 90420,
  "underactivity|low|Na/K,DHEA-S|one past alarm bound": 90421,
  "underactivity|low|Na/K,DHEA-S|two past lab range": 90422,
  "underactivity|low|Na/K,Pregnenolone|all mild": 90423,
  "underactivity|low|Na/K,Pregnenolone|one past mid": 90424,
  "underactivity|low|Na/K,Pregnenolone|two or more past mid": 90425,
  "underactivity|low|Na/K,Pregnenolone|one past lab range": 90426,
  "underactivity|low|Na/K,Pregnenolone|one past alarm bound": 90427,
  "underactivity|low|Na/K,Pregnenolone|two past lab range": 90428,
  "underactivity|low|Cortisol,DHEA-S|all mild": 90429,
  "underactivity|low|Cortisol,DHEA-S|one past mid": 90430,
  "underactivity|low|Cortisol,DHEA-S|two or more past mid": 90431,
  "underactivity|low|Cortisol,DHEA-S|one past lab range": 90432,
  "underactivity|low|Cortisol,DHEA-S|one past alarm bound": 90433,
  "underactivity|low|Cortisol,DHEA-S|two past lab range": 90434,
  "underactivity|low|Cortisol,Pregnenolone|all mild": 90435,
  "underactivity|low|Cortisol,Pregnenolone|one past mid": 90436,
  "underactivity|low|Cortisol,Pregnenolone|two or more past mid": 90437,
  "underactivity|low|Cortisol,Pregnenolone|one past lab range": 90438,
  "underactivity|low|Cortisol,Pregnenolone|one past alarm bound": 90439,
  "underactivity|low|Cortisol,Pregnenolone|two past lab range": 90440,
  "underactivity|low|Na/K,Cortisol,DHEA-S|all mild": 90441,
  "underactivity|low|Na/K,Cortisol,DHEA-S|one past mid": 90442,
  "underactivity|low|Na/K,Cortisol,DHEA-S|two or more past mid": 90443,
  "underactivity|low|Na/K,Cortisol,DHEA-S|one past lab range": 90444,
  "underactivity|low|Na/K,Cortisol,DHEA-S|one past alarm bound": 90445,
  "underactivity|low|Na/K,Cortisol,DHEA-S|two past lab range": 90446,
  "underactivity|low|Na/K,Cortisol,DHEA-S|three or more past lab range": 90447,
  "underactivity|low|Na/K,Cortisol,Pregnenolone|all mild": 90448,
  "underactivity|low|Na/K,Cortisol,Pregnenolone|one past mid": 90449,
  "underactivity|low|Na/K,Cortisol,Pregnenolone|two or more past mid": 90450,
  "underactivity|low|Na/K,Cortisol,Pregnenolone|one past lab range": 90451,
  "underactivity|low|Na/K,Cortisol,Pregnenolone|one past alarm bound": 90452,
  "underactivity|low|Na/K,Cortisol,Pregnenolone|two past lab range": 90453,
  "underactivity|low|Na/K,Cortisol,Pregnenolone|three or more past lab range": 90454,
  "underactivity|low|Na/K,DHEA-S,Pregnenolone|all mild": 90455,
  "underactivity|low|Na/K,DHEA-S,Pregnenolone|one past mid": 90456,
  "underactivity|low|Na/K,DHEA-S,Pregnenolone|two or more past mid": 90457,
  "underactivity|low|Na/K,DHEA-S,Pregnenolone|one past lab range": 90458,
  "underactivity|low|Na/K,DHEA-S,Pregnenolone|one past alarm bound": 90459,
  "underactivity|low|Na/K,DHEA-S,Pregnenolone|two past lab range": 90460,
  "underactivity|low|Na/K,DHEA-S,Pregnenolone|three or more past lab range": 90461,
  "underactivity|low|Cortisol,DHEA-S,Pregnenolone|all mild": 90462,
  "underactivity|low|Cortisol,DHEA-S,Pregnenolone|one past mid": 90463,
  "underactivity|low|Cortisol,DHEA-S,Pregnenolone|two or more past mid": 90464,
  "underactivity|low|Cortisol,DHEA-S,Pregnenolone|one past lab range": 90465,
  "underactivity|low|Cortisol,DHEA-S,Pregnenolone|one past alarm bound": 90466,
  "underactivity|low|Cortisol,DHEA-S,Pregnenolone|two past lab range": 90467,
  "underactivity|low|Cortisol,DHEA-S,Pregnenolone|three or more past lab range": 90468,
  "underactivity|low|Na/K,Cortisol,DHEA-S,Pregnenolone|all mild": 90469,
  "underactivity|low|Na/K,Cortisol,DHEA-S,Pregnenolone|one past mid": 90470,
  "underactivity|low|Na/K,Cortisol,DHEA-S,Pregnenolone|two or more past mid": 90471,
  "underactivity|low|Na/K,Cortisol,DHEA-S,Pregnenolone|one past lab range": 90472,
  "underactivity|low|Na/K,Cortisol,DHEA-S,Pregnenolone|one past alarm bound": 90473,
  "underactivity|low|Na/K,Cortisol,DHEA-S,Pregnenolone|two past lab range": 90474,
  "underactivity|low|Na/K,Cortisol,DHEA-S,Pregnenolone|three or more past lab range": 90475,
  "overactivity|high|Na/K|all mild": 90476,
  "overactivity|high|Na/K|one past mid": 90477,
  "overactivity|high|Na/K|one past lab range": 90478,
  "overactivity|high|Na/K|one past alarm bound": 90479,
  "overactivity|high|Cortisol|all mild": 90480,
  "overactivity|high|Cortisol|one past mid": 90481,
  "overactivity|high|Cortisol|one past lab range": 90482,
  "overactivity|high|Cortisol|one past alarm bound": 90483,
  "overactivity|high|DHEA-S|all mild": 90484,
  "overactivity|high|DHEA-S|one past mid": 90485,
  "overactivity|high|DHEA-S|one past lab range": 90486,
  "overactivity|high|DHEA-S|one past alarm bound": 90487,
  "overactivity|high|Pregnenolone|all mild": 90488,
  "overactivity|high|Pregnenolone|one past mid": 90489,
  "overactivity|high|Pregnenolone|one past lab range": 90490,
  "overactivity|high|Pregnenolone|one past alarm bound": 90491,
  "overactivity|high|Na/K,Cortisol|all mild": 90492,
  "overactivity|high|Na/K,Cortisol|one past mid": 90493,
  "overactivity|high|Na/K,Cortisol|two or more past mid": 90494,
  "overactivity|high|Na/K,Cortisol|one past lab range": 90495,
  "overactivity|high|Na/K,Cortisol|one past alarm bound": 90496,
  "overactivity|high|Na/K,Cortisol|two past lab range": 90497,
  "overactivity|high|Na/K,DHEA-S|all mild": 90498,
  "overactivity|high|Na/K,DHEA-S|one past mid": 90499,
  "overactivity|high|Na/K,DHEA-S|two or more past mid": 90500,
  "overactivity|high|Na/K,DHEA-S|one past lab range": 90501,
  "overactivity|high|Na/K,DHEA-S|one past alarm bound": 90502,
  "overactivity|high|Na/K,DHEA-S|two past lab range": 90503,
  "overactivity|high|Na/K,Pregnenolone|all mild": 90504,
  "overactivity|high|Na/K,Pregnenolone|one past mid": 90505,
  "overactivity|high|Na/K,Pregnenolone|two or more past mid": 90506,
  "overactivity|high|Na/K,Pregnenolone|one past lab range": 90507,
  "overactivity|high|Na/K,Pregnenolone|one past alarm bound": 90508,
  "overactivity|high|Na/K,Pregnenolone|two past lab range": 90509,
  "overactivity|high|Cortisol,DHEA-S|all mild": 90510,
  "overactivity|high|Cortisol,DHEA-S|one past mid": 90511,
  "overactivity|high|Cortisol,DHEA-S|two or more past mid": 90512,
  "overactivity|high|Cortisol,DHEA-S|one past lab range": 90513,
  "overactivity|high|Cortisol,DHEA-S|one past alarm bound": 90514,
  "overactivity|high|Cortisol,DHEA-S|two past lab range": 90515,
  "overactivity|high|Cortisol,Pregnenolone|all mild": 90516,
  "overactivity|high|Cortisol,Pregnenolone|one past mid": 90517,
  "overactivity|high|Cortisol,Pregnenolone|two or more past mid": 90518,
  "overactivity|high|Cortisol,Pregnenolone|one past lab range": 90519,
  "overactivity|high|Cortisol,Pregnenolone|one past alarm bound": 90520,
  "overactivity|high|Cortisol,Pregnenolone|two past lab range": 90521,
  "overactivity|high|DHEA-S,Pregnenolone|all mild": 90522,
  "overactivity|high|DHEA-S,Pregnenolone|one past mid": 90523,
  "overactivity|high|DHEA-S,Pregnenolone|two or more past mid": 90524,
  "overactivity|high|DHEA-S,Pregnenolone|one past lab range": 90525,
  "overactivity|high|DHEA-S,Pregnenolone|one past alarm bound": 90526,
  "overactivity|high|DHEA-S,Pregnenolone|two past lab range": 90527,
  "overactivity|high|Na/K,Cortisol,DHEA-S|all mild": 90528,
  "overactivity|high|Na/K,Cortisol,DHEA-S|one past mid": 90529,
  "overactivity|high|Na/K,Cortisol,DHEA-S|two or more past mid": 90530,
  "overactivity|high|Na/K,Cortisol,DHEA-S|one past lab range": 90531,
  "overactivity|high|Na/K,Cortisol,DHEA-S|one past alarm bound": 90532,
  "overactivity|high|Na/K,Cortisol,DHEA-S|two past lab range": 90533,
  "overactivity|high|Na/K,Cortisol,DHEA-S|three or more past lab range": 90534,
  "overactivity|high|Na/K,Cortisol,Pregnenolone|all mild": 90535,
  "overactivity|high|Na/K,Cortisol,Pregnenolone|one past mid": 90536,
  "overactivity|high|Na/K,Cortisol,Pregnenolone|two or more past mid": 90537,
  "overactivity|high|Na/K,Cortisol,Pregnenolone|one past lab range": 90538,
  "overactivity|high|Na/K,Cortisol,Pregnenolone|one past alarm bound": 90539,
  "overactivity|high|Na/K,Cortisol,Pregnenolone|two past lab range": 90540,
  "overactivity|high|Na/K,Cortisol,Pregnenolone|three or more past lab range": 90541,
  "overactivity|high|Na/K,DHEA-S,Pregnenolone|all mild": 90542,
  "overactivity|high|Na/K,DHEA-S,Pregnenolone|one past mid": 90543,
  "overactivity|high|Na/K,DHEA-S,Pregnenolone|two or more past mid": 90544,
  "overactivity|high|Na/K,DHEA-S,Pregnenolone|one past lab range": 90545,
  "overactivity|high|Na/K,DHEA-S,Pregnenolone|one past alarm bound": 90546,
  "overactivity|high|Na/K,DHEA-S,Pregnenolone|two past lab range": 90547,
  "overactivity|high|Na/K,DHEA-S,Pregnenolone|three or more past lab range": 90548,
  "overactivity|high|Cortisol,DHEA-S,Pregnenolone|all mild": 90549,
  "overactivity|high|Cortisol,DHEA-S,Pregnenolone|one past mid": 90550,
  "overactivity|high|Cortisol,DHEA-S,Pregnenolone|two or more past mid": 90551,
  "overactivity|high|Cortisol,DHEA-S,Pregnenolone|one past lab range": 90552,
  "overactivity|high|Cortisol,DHEA-S,Pregnenolone|one past alarm bound": 90553,
  "overactivity|high|Cortisol,DHEA-S,Pregnenolone|two past lab range": 90554,
  "overactivity|high|Cortisol,DHEA-S,Pregnenolone|three or more past lab range": 90555,
  "overactivity|high|Na/K,Cortisol,DHEA-S,Pregnenolone|all mild": 90556,
  "overactivity|high|Na/K,Cortisol,DHEA-S,Pregnenolone|one past mid": 90557,
  "overactivity|high|Na/K,Cortisol,DHEA-S,Pregnenolone|two or more past mid": 90558,
  "overactivity|high|Na/K,Cortisol,DHEA-S,Pregnenolone|one past lab range": 90559,
  "overactivity|high|Na/K,Cortisol,DHEA-S,Pregnenolone|one past alarm bound": 90560,
  "overactivity|high|Na/K,Cortisol,DHEA-S,Pregnenolone|two past lab range": 90561,
  "overactivity|high|Na/K,Cortisol,DHEA-S,Pregnenolone|three or more past lab range": 90562,
  "dominance|▲Cortisol,▼DHEA-S|all mild": 90563,
  "dominance|▲Cortisol,▼DHEA-S|one past mid": 90564,
  "dominance|▲Cortisol,▼DHEA-S|two or more past mid": 90565,
  "dominance|▲Cortisol,▼DHEA-S|one past lab range": 90566,
  "dominance|▲Cortisol,▼DHEA-S|one past alarm bound": 90567,
  "dominance|▲Cortisol,▼DHEA-S|two past lab range": 90568,
  "dominance|▲Cortisol,▼Pregnenolone|all mild": 90569,
  "dominance|▲Cortisol,▼Pregnenolone|one past mid": 90570,
  "dominance|▲Cortisol,▼Pregnenolone|two or more past mid": 90571,
  "dominance|▲Cortisol,▼Pregnenolone|one past lab range": 90572,
  "dominance|▲Cortisol,▼Pregnenolone|one past alarm bound": 90573,
  "dominance|▲Cortisol,▼Pregnenolone|two past lab range": 90574,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S|all mild": 90575,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S|all mild": 90576,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S|one past mid": 90577,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S|one past mid": 90578,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S|two or more past mid": 90579,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S|two or more past mid": 90580,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S|one past lab range": 90581,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S|one past lab range": 90582,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S|one past alarm bound": 90583,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S|one past alarm bound": 90584,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S|two past lab range": 90585,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S|two past lab range": 90586,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S|three or more past lab range": 90587,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S|three or more past lab range": 90588,
  "dominance|▼Na/K,▲Cortisol,▼Pregnenolone|all mild": 90589,
  "dominance|▲Na/K,▲Cortisol,▼Pregnenolone|all mild": 90590,
  "dominance|▼Na/K,▲Cortisol,▼Pregnenolone|one past mid": 90591,
  "dominance|▲Na/K,▲Cortisol,▼Pregnenolone|one past mid": 90592,
  "dominance|▼Na/K,▲Cortisol,▼Pregnenolone|two or more past mid": 90593,
  "dominance|▲Na/K,▲Cortisol,▼Pregnenolone|two or more past mid": 90594,
  "dominance|▼Na/K,▲Cortisol,▼Pregnenolone|one past lab range": 90595,
  "dominance|▲Na/K,▲Cortisol,▼Pregnenolone|one past lab range": 90596,
  "dominance|▼Na/K,▲Cortisol,▼Pregnenolone|one past alarm bound": 90597,
  "dominance|▲Na/K,▲Cortisol,▼Pregnenolone|one past alarm bound": 90598,
  "dominance|▼Na/K,▲Cortisol,▼Pregnenolone|two past lab range": 90599,
  "dominance|▲Na/K,▲Cortisol,▼Pregnenolone|two past lab range": 90600,
  "dominance|▼Na/K,▲Cortisol,▼Pregnenolone|three or more past lab range": 90601,
  "dominance|▲Na/K,▲Cortisol,▼Pregnenolone|three or more past lab range": 90602,
  "dominance|▲Cortisol,▼DHEA-S,▼Pregnenolone|all mild": 90603,
  "dominance|▲Cortisol,▼DHEA-S,▲Pregnenolone|all mild": 90604,
  "dominance|▲Cortisol,▲DHEA-S,▼Pregnenolone|all mild": 90605,
  "dominance|▲Cortisol,▼DHEA-S,▼Pregnenolone|one past mid": 90606,
  "dominance|▲Cortisol,▼DHEA-S,▲Pregnenolone|one past mid": 90607,
  "dominance|▲Cortisol,▲DHEA-S,▼Pregnenolone|one past mid": 90608,
  "dominance|▲Cortisol,▼DHEA-S,▼Pregnenolone|two or more past mid": 90609,
  "dominance|▲Cortisol,▼DHEA-S,▲Pregnenolone|two or more past mid": 90610,
  "dominance|▲Cortisol,▲DHEA-S,▼Pregnenolone|two or more past mid": 90611,
  "dominance|▲Cortisol,▼DHEA-S,▼Pregnenolone|one past lab range": 90612,
  "dominance|▲Cortisol,▼DHEA-S,▲Pregnenolone|one past lab range": 90613,
  "dominance|▲Cortisol,▲DHEA-S,▼Pregnenolone|one past lab range": 90614,
  "dominance|▲Cortisol,▼DHEA-S,▼Pregnenolone|one past alarm bound": 90615,
  "dominance|▲Cortisol,▼DHEA-S,▲Pregnenolone|one past alarm bound": 90616,
  "dominance|▲Cortisol,▲DHEA-S,▼Pregnenolone|one past alarm bound": 90617,
  "dominance|▲Cortisol,▼DHEA-S,▼Pregnenolone|two past lab range": 90618,
  "dominance|▲Cortisol,▼DHEA-S,▲Pregnenolone|two past lab range": 90619,
  "dominance|▲Cortisol,▲DHEA-S,▼Pregnenolone|two past lab range": 90620,
  "dominance|▲Cortisol,▼DHEA-S,▼Pregnenolone|three or more past lab range": 90621,
  "dominance|▲Cortisol,▼DHEA-S,▲Pregnenolone|three or more past lab range": 90622,
  "dominance|▲Cortisol,▲DHEA-S,▼Pregnenolone|three or more past lab range": 90623,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|all mild": 90624,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|all mild": 90625,
  "dominance|▼Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|all mild": 90626,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|all mild": 90627,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|all mild": 90628,
  "dominance|▲Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|all mild": 90629,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|one past mid": 90630,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|one past mid": 90631,
  "dominance|▼Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|one past mid": 90632,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|one past mid": 90633,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|one past mid": 90634,
  "dominance|▲Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|one past mid": 90635,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|two or more past mid": 90636,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|two or more past mid": 90637,
  "dominance|▼Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|two or more past mid": 90638,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|two or more past mid": 90639,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|two or more past mid": 90640,
  "dominance|▲Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|two or more past mid": 90641,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|one past lab range": 90642,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|one past lab range": 90643,
  "dominance|▼Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|one past lab range": 90644,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|one past lab range": 90645,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|one past lab range": 90646,
  "dominance|▲Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|one past lab range": 90647,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|one past alarm bound": 90648,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|one past alarm bound": 90649,
  "dominance|▼Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|one past alarm bound": 90650,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|one past alarm bound": 90651,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|one past alarm bound": 90652,
  "dominance|▲Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|one past alarm bound": 90653,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|two past lab range": 90654,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|two past lab range": 90655,
  "dominance|▼Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|two past lab range": 90656,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|two past lab range": 90657,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|two past lab range": 90658,
  "dominance|▲Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|two past lab range": 90659,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|three or more past lab range": 90660,
  "dominance|▼Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|three or more past lab range": 90661,
  "dominance|▼Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|three or more past lab range": 90662,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▼Pregnenolone|three or more past lab range": 90663,
  "dominance|▲Na/K,▲Cortisol,▼DHEA-S,▲Pregnenolone|three or more past lab range": 90664,
  "dominance|▲Na/K,▲Cortisol,▲DHEA-S,▼Pregnenolone|three or more past lab range": 90665,
  "reserve|low|DHEA-S|all mild": 90666,
  "reserve|low|DHEA-S|one past mid": 90667,
  "reserve|low|DHEA-S|one past lab range": 90668,
  "reserve|low|DHEA-S|one past alarm bound": 90669,
  "reserve|low|Pregnenolone|all mild": 90670,
  "reserve|low|Pregnenolone|one past mid": 90671,
  "reserve|low|Pregnenolone|one past lab range": 90672,
  "reserve|low|Pregnenolone|one past alarm bound": 90673,
  "reserve|low|DHEA-S,Pregnenolone|all mild": 90674,
  "reserve|low|DHEA-S,Pregnenolone|one past mid": 90675,
  "reserve|low|DHEA-S,Pregnenolone|two or more past mid": 90676,
  "reserve|low|DHEA-S,Pregnenolone|one past lab range": 90677,
  "reserve|low|DHEA-S,Pregnenolone|one past alarm bound": 90678,
  "reserve|low|DHEA-S,Pregnenolone|two past lab range": 90679,
};
